import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';

@Component({
    selector: 'app-restricted',
    templateUrl: './app-restricted.component.html',
    styleUrls: ['./app-restricted.component.scss'],
})
export class AppRestrictedComponent implements OnInit {

    private unregisterBackButtonAction: any;
    public backgroundClass = "blue-background";
    public addStars:boolean = true;
    public availableRegionLink;

    constructor(
        protected platform: Platform,
        private appLinks: AppLinksService,
        private configService: ConfigService
    ) {
    
    }

    ngOnInit(){
        this.availableRegionLink = this.configService.getConfig().FEATURE_AVAILABLE_REGION_URL ? this.configService.getConfig().FEATURE_AVAILABLE_REGION_URL : 'https://support.stardustsocialcasino.com/hc/en-us/articles/360052938934-I-m-getting-the-error-message-not-available-in-your-location-what-does-this-mean-' 
    }

    ionViewDidLoad() {
        this.initializeBackButtonCustomHandler();
    }

    ionViewWillLeave() {
        this.unregisterBackButtonAction && this.unregisterBackButtonAction();
    }

    initializeBackButtonCustomHandler() {
        // old this.unregisterBackButtonAction = this.platform.registerBackButtonAction(function(event){
        this.platform.backButton.subscribeWithPriority(101, (event) => {
            console.log('Prevent Back Button Page Change... You Stuck!');
        },); // Priority 101 will override back button handling (we set in app.component.ts) as it is bigger then priority 100 configured in app.component.ts file */
    }

    checkRegions(){
        this.appLinks.openExternalPage(this.availableRegionLink);
    }

   
}
